<template>
  <transition name="pop">
    <div class="modal-mask modal-backdrop">
      <loading v-model:active="loading" />
      <div class="modal-wrapper animate__fadeInDown animate__animated">
        <div class="modal-dialogs" role="document">
          <div class="modal-content modal-xs modal-frame">
            <div class="modal-body mdScroll px-3 pb-5">
              <h3 class="tm5 modal-title d-inline-block">Add Market Item</h3>

              <a
                href="JavaScript:void(0)"
                class="
                  btn-cross
                  text-right
                  close-modal
                  animate__fadeInDown animate__animated
                "
                @click="hideModal($event)"
                >&times;</a
              >
              <p v-if="error">{{ error }}</p>
              <form @submit.prevent="addMarket()" class="form-wrapper">
                <div class="row m-0">
                  <div class="col-6">
                    <div class="form-group">
                      <label for="">Select Schema</label>
                      <select
                        class="custom-select"
                        v-model="schema"
                        @change="schemaSelected()"
                      >
                        <option selected>Select one</option>
                        <option value="guns">Guns</option>
                        <option value="characters">Character</option>
                        <option value="resource">Resource</option>
                        <option v-for="(opt,code) in gameItems" :key="code" :value="code">{{opt}}</option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="mx-auto col-6"
                    v-if="schema == 'guns' || schema == 'characters' || schema=='resource'"
                  >
                    <div class="form-group">
                      <label for="assetID">Asset Template ID</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="asset template id"
                        v-model="asset_t"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label for="price">Price</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="price e.g 1.2200 WWS"
                        v-model="price"
                      />
                    </div>
                  </div>
                  <div class="col-6 mb-0">
                    <div class="form-group">
                      <label for="supply">Supply</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="supply"
                        v-model="supply"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <button type="submit" class="btn-primary btn w-100 mt-2">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ApiService from "../../services/index";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast, POSITION } from "vue-toastification";
const toast = useToast();
export default {
  name: "MarketModal",
  components: {
    Loading,
  },
  props: ["error", "showModel"],
  showModal: true,
  data() {
    return {
      amount: null,
      amountWithdraw: null,
      loading: false,
      schema: "",
      price: "",
      supply: "0",
      asset_t: "",
      gameItems: {},
    };
  },
  created() {
    this.gameItems = ApiService.gameItemList();
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    schemaSelected() {
      if (this.schema == "guns" || this.schema == "characters") {
        this.asset_t = "";
      } else {
        switch (this.schema) {
          case "GUNP":
            this.asset_t = 1;
            break;
          case "FSTEW":
            this.asset_t = 2;
            break;
          case "CBREAD":
            this.asset_t = 3;
            break;
          case "BEANS":
            this.asset_t = 18;
            break;
          case "JERKY":
            this.asset_t = 19;
            break;
          case "RESIN":
            this.asset_t = 4;
            break;
          case "METALP":
            this.asset_t = 5;
            break;
          case "IRON":
            this.asset_t = 6;
            break;
          case "ROPE":
            this.asset_t = 7;
            break;
          case "SPOON":
            this.asset_t = 8;
            break;
          case "SAND":
            this.asset_t = 9;
            break;
          case "TIMBER":
            this.asset_t = 10;
            break;

          case "CLOTH":
            this.asset_t = 11;
            break;
          case "PLASTIC":
            this.asset_t = 12;
            break;

          case "ASKIN":
            this.asset_t = 13;
            break;
          case "MSPRING":
            this.asset_t = 14;
            break;

          case "DYNMT":
            this.asset_t = 15;
            break;

          case "PISTREV":
            this.asset_t = 16;
            break;

          case "FIRARM":
            this.asset_t = 17;
            break;

          default:
            break;
        }
      }
    },
    async addMarket() {
      if (
        this.asset_t == "" ||
        this.price == "" ||
        this.schema == "" ||
        this.supply == ""
      ) {
        toast.error("All fields are required..", {
          position: POSITION.TOP_RIGHT,
          timeout: 2000,
          hideProgressBar: false,
        });
        return;
      } else {
        this.isLoading = true;
        let isGameItem =
          this.schema == "guns" || this.schema == "characters" || this.schema=="resource" ? false : true;
        const data = {
          contract: process.env.VUE_APP_CONTRACT,
          action: "newmarket",
          data: {
            asset_t: this.asset_t,
            price: this.price,
            schema: this.schema,
            supply: this.supply,
            is_in_game_item: isGameItem,
          },
        };
        await ApiService.transaction(
          data,
          (res) => {
            if (res.processed) {
              toast.success("Transaction successfull");
              this.isLoading = false;
               ApiService.getHeaderContents();
            }
          },
          (error) => {
            toast.error(ApiService.errorFormat(error));
            this.isLoading = false;
          }
        );
      }
    },
  },
};
</script>
  
  <style scoped>
.progress-cont .progress__bar {
  height: 9px !important;
}

span {
  font-family: "Freckle Face", cursive;
  letter-spacing: 1px;
}

.modal-wrapper .modal-content {
  padding: 42px 50px 50px 42px;
  border: none !important;
}
.modal-wrapper .modal-content .modal-body {
  background: #000;
}
.modal-wrapper .modal-dialogs .modal-content .close-modal {
  top: 8px;
  right: 20px;
}
.modal-content .modal-body .form-group {
  /* margin-bottom: 10px; */
  text-align: left;
  color: #fff;
}
.form-group .label {
  margin-bottom: 0;
}
</style>
  